import React from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';

export const COPY = defineMessages({
  CREATE_SURVEY: {
    id: 'ButtonCreate.createSurvey',
    defaultMessage: 'Create survey',
    description:
      '[Type: Label][Vis.: high] - This is the create survey addon button on the header.',
  },
});

const ButtonCreate = () => (
  <Button
    size="sm"
    color="alt"
    href={createURL('/create/', { ut_source: 'header' })}
  >
    <T desc={COPY.CREATE_SURVEY} />
  </Button>
);

export default ButtonCreate;
